
  import { useStore } from 'vuex'
  import { computed, defineComponent, ref } from "vue";
  
  import * as Connection from "./src/connection";
  import * as Utils from "./src/Utils";
  
  import MonitorComponent from '@/components/monitor-component.vue'
  
  export default defineComponent({
    components: {
      MonitorComponent
    },
    setup() {
      const store = useStore()
      const monitor = ref()
  
      // display the item from store state.
      const isLoggedIn = computed(() => {
        return store.getters.isLoggedIn;
      });
  
      const defaultPresetName = computed(() => {
        return store.getters.defaultPresetName.substring(0, 15);
      });
  
      const isElectron = computed(() => {
        return Utils.isElectron();
      });
  
      const applyChanges = () => {      
        monitor.value.stopMonitoring();
        monitor.value.doClear();
        
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).Connection = Connection;
        Connection.loginStatus.userDataConfig.applyChanges(Connection.connection);
        
      };
  
      const sidebarOpen = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (document as any).getElementById("mySidebar").style.display = "block";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (document as any).getElementById("nav").style.display = "none";
      };
  
      const sidebarClose = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (document as any).getElementById("main").style.marginLeft = "0%";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (document as any).getElementById("mySidebar").style.display = "none";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (document as any).getElementById("nav").style.display = "inline-block";
      };
  
      const shutdownQuit = () => {
        Connection.connection.wcuserdata.applicationQuit();
        if (Utils.isElectron()) {
          Utils.quitElectron();
        }
      };
  
      return {shutdownQuit,sidebarClose,sidebarOpen,applyChanges,
          isElectron, defaultPresetName, isLoggedIn, monitor}
    },
  });
  
  
  